export default {
    namespaced: true,
    state: () => ({
        dialog: {
            title: null,
            text: null,
            button: { cancel: { show: false, text: null }, done: { show: false, text: null } },
            next: null,
            show: false,
        }
    }),
    getters: {
        data(state) {
            return state.dialog
        },
        title(state) {
            return state.dialog.title
        },
        text(state) {
            return state.dialog.text
        },
        button(state) {
            return state.dialog.button
        },
        next(state) {
            return state.dialog.next
        },
        show(state) {
            return state.dialog.show
        }
    },
    mutations: {
        setDialog(state, payload) {
            state.dialog = payload
        },
    },
    actions: {
        setDialog({ commit }, dialog) {
            commit('setDialog', dialog)
        },
        dismiss ({ commit }) {
            const dialog = {
                title: null,
                text: null,
                button: { cancel: { show: false, text: null }, done: { show: false, text: null } },
                next: null,
                show: false
            }
            commit('setDialog', dialog)
        }
    },
}
